/* eslint-disable @next/next/no-img-element */
import { ColorBlur } from "../ColorBlur"
import { HoverSkew } from "../HoverSkew"
import { Heading, Paragraph, Section } from "../misc"
import Hero from "public/marketing/triggers.png"

export const Triggers = () => {
  return (
    <Section className="text-left">
      <ColorBlur></ColorBlur>

      <HoverSkew className="z-[1] !py-0 pl-8 md:!pl-16 !pr-0">
        <div className="flex flex-col lg:flex-row gap-6 md:gap-10 justify-center items-stretch  pt-8 md:pt-10">
          <div className="flex flex-col items-start justify-center lg:pb-9">
            <Heading>Remotely control when paywalls show</Heading>
            <Paragraph>
              Show paywalls when users trigger events, land on a specific page, or even every app
              open.
            </Paragraph>
          </div>

          <div
            className="w-full lg:w-[700px] h-full md:min-h-[200px] min-h-[140px] mt-auto"
            style={{
              background: `url(${Hero.src})`,
              backgroundSize: "auto 120%",
              backgroundRepeat: "repeat-x",
              backgroundPosition: "0px 0px",
            }}
          ></div>
        </div>
      </HoverSkew>
    </Section>
  )
}
